import { BuilderConfig } from '../../types/Builder';
import BusinessHubVideoHero, { VideoHeroProps } from './business-hub-video-hero';

export const BusinessHubVideoHeroBuilderConfig = {
    name: 'Business Video Hero',
    inputs: [
        {
            name: 'videoHero',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'imagePlaceholder',
            type: 'file',
            defaultValue: '',
        },
        {
            name: 'borderRadiusBackground',
            type: 'boolean',
        },
        {
            name: 'title',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'ctaText',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'ctaLink',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'staticImageOnMobile',
            type: 'file',
            defaultValue: '',
        },
    ],
};

const builderConfig: BuilderConfig<VideoHeroProps> = {
    component: BusinessHubVideoHero,
    config: BusinessHubVideoHeroBuilderConfig,
};

export default builderConfig;
